import { Checkbox as MantineCheckbox, CheckboxProps } from '@mantine/core';
import React, { forwardRef } from 'react';
import { useStyles } from './Checkbox.styles';
import CheckIcon from '../CheckIcon';

function CheckboxBase(props: CheckboxProps, ref: React.Ref<HTMLInputElement>) {
  const { classes } = useStyles();
  return (
    <MantineCheckbox
      {...props}
      ref={ref}
      classNames={classes}
      icon={CheckIcon}
    />
  );
}

export const Checkbox = forwardRef(CheckboxBase);
